module.exports = __webpack_public_path__ + "static/img/26_pro.204a085.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/26_pro.jpg
// module id = Scgs
// module chunks = 0